import { Pipe, PipeTransform } from '@angular/core';
import { AssetColorLabel } from '@nusign/picflow-backend-types';

@Pipe({
  name: 'colorLabelColor',
  standalone: true,
})
export class ColorLabelColorPipe implements PipeTransform {
  transform(label: AssetColorLabel): string {
    if (label === 'blue') return 'simple-blue';
    if (label === 'green') return 'simple-green';
    if (label === 'orange') return 'simple-orange';
    if (label === 'purple') return 'simple-purple';
    if (label === 'red') return 'simple-warn';
  }
}
